"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaSeries = void 0;
var __1 = require("../..");
var constants_1 = require("../../../scales/constants");
var constants_2 = require("../../../specs/constants");
var spec_factory_1 = require("../../../state/spec_factory");
var specs_1 = require("../utils/specs");
var defaultProps = {
    chartType: __1.ChartType.XYAxis,
    specType: constants_2.SpecType.Series,
    seriesType: specs_1.SeriesType.Area,
    groupId: specs_1.DEFAULT_GLOBAL_ID,
    xScaleType: constants_1.ScaleType.Linear,
    yScaleType: constants_1.ScaleType.Linear,
    xAccessor: 'x',
    yAccessors: ['y'],
    hideInLegend: false,
    histogramModeAlignment: specs_1.HistogramModeAlignments.Center,
};
exports.AreaSeries = (0, spec_factory_1.getConnect)()((0, spec_factory_1.specComponentFactory)(defaultProps));
//# sourceMappingURL=area_series.js.map